"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableActionDetail_1 = require("../../../../../../shared/components/table_actions/TableActionDetail");
var CmsPostCategoryList = /** @class */ (function (_super) {
    __extends(CmsPostCategoryList, _super);
    function CmsPostCategoryList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 150,
            }, {
                title: 'Тэг',
                dataIndex: _this.props.data.dk_tag,
                key: _this.props.data.dk_tag,
                width: 150,
            }, {
                title: 'Брэнд',
                dataIndex: _this.props.data.dk_brand_title,
                key: _this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Описание',
                dataIndex: _this.props.data.dk_description,
                key: _this.props.data.dk_description,
                width: 150,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDetail_1.default, { hint: "\u041A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0439", onClick: function () { _this.onDetailsClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 110
            }
        ];
        return _this;
    }
    CmsPostCategoryList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    CmsPostCategoryList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    CmsPostCategoryList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    CmsPostCategoryList.prototype.onDetailsClick = function (record) {
        if (this.props.onDetailsClick) {
            this.props.onDetailsClick(record);
        }
    };
    CmsPostCategoryList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    CmsPostCategoryList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    CmsPostCategoryList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    CmsPostCategoryList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    CmsPostCategoryList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    CmsPostCategoryList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                } })));
    };
    return CmsPostCategoryList;
}(React.Component));
exports.default = CmsPostCategoryList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_posts/ui/component/CmsPostCategoryList.tsx
// module id = 2378
// module chunks = 0